import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWallet = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 2.75,
			y: 4.75,
			width: 18.5,
			height: 14.5,
			rx: 3.25,
			stroke: "currentColor",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3 13H9.4C9.73137 13 10.0053 13.2783 10.1504 13.5762C10.3564 13.9991 10.8442 14.5 12 14.5C13.1558 14.5 13.6436 13.9991 13.8496 13.5762C13.9947 13.2783 14.2686 13 14.6 13H21",
			stroke: "currentColor",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3 9H21",
			stroke: "currentColor",
			strokeWidth: 1.5
		})
	]
});
export default SvgWallet;
